import { Box, IconButton, Slider, Tooltip } from '@mui/material'
import { FC } from 'react'
import { MIN_VOLUME, MAX_VOLUME } from '../constants'
import WarningIcon from '@mui/icons-material/Warning'

export type VolumeControlProps = {
  onClick: () => void
  playerVolume: number
  playerMuted: boolean
  onChange: (_event: Event, newValue: number | number[]) => void
  icons: {
    mutedIcon?: React.ReactNode
    unmutedIcon?: React.ReactNode
  }
  errorMessage?: string
  testIds: {
    muteButton: string
    unmuteButton: string
    volumeSlider: string
  }
}

export const VolumeControl: FC<VolumeControlProps> = ({ onClick, playerVolume, playerMuted, onChange, icons, errorMessage, testIds }) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', marginLeft: 'var(--spacing-s)' }}>
      <Tooltip title={errorMessage}>
        <Box sx={{ marginRight: 'var(--spacing-s)', position: 'relative' }}>
          <IconButton
            onClick={onClick}
            size="small"
            aria-label={playerMuted ? 'Unmute' : 'Mute'}
            data-testid={playerVolume === MIN_VOLUME ? testIds.unmuteButton : testIds.muteButton}
          >
            {playerMuted ? icons.mutedIcon : icons.unmutedIcon}
          </IconButton>
          {errorMessage && (
            <WarningIcon
              sx={{
                color: 'var(--text-disabled)',
                position: 'absolute',
                bottom: 0,
                right: 0,
                height: '45%',
                width: '45%',
                backgroundColor: 'var(--white-70)',
                borderRadius: '50%',
                boxShadow: '0 0 2px 2px var(--white-70)',
                pointerEvents: 'none'
              }}
            />
          )}
        </Box>
      </Tooltip>
      <Slider
        value={playerMuted ? 0 : playerVolume}
        onChange={onChange}
        valueLabelDisplay="auto"
        min={MIN_VOLUME}
        max={MAX_VOLUME}
        data-testid={testIds.volumeSlider}
        sx={{
          width: 100,
          color: 'var(--yellow-500)',
          marginRight: 'var(--spacing-s)',
          '& .MuiSlider-track': {
            height: 5
          },
          '& .MuiSlider-rail': {
            height: 5,
            opacity: 0.3,
            backgroundColor: 'var(--neutral-300)'
          },
          '& .MuiSlider-thumb': {
            color: 'var(--yellow-500)',
            '&:hover, &.Mui-focusVisible': {
              boxShadow: '0px 0px 0px 8px var(--orange-500-t18)'
            }
          }
        }}
      />
    </Box>
  )
}
